import React from 'react';
import { Card, Typography, Row, Col, Space, Divider, Tag } from 'antd';
import { CopyButton } from './CopyButton';

const { Title, Text } = Typography;

export const CardCorralon = ({ item }) => {
  return (
    <Card style={{ marginBottom: 16 }}>
      <Space direction="vertical" style={{ width: '100%' }} size="small">
        <div>
          <Title level={4} style={{ marginTop: 0, marginBottom: 4, display: 'inline-block' }}>
            {item.cdr}
          </Title>
          <Tag color="purple" style={{ marginLeft: 8 }}>CORRALÓN</Tag>
        </div>

        <div>
          <Text type="secondary">{item.puesto}</Text>
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <Row gutter={[8, 8]}>
          <Col span={12}>
            <div>
              <Text strong>Responsable</Text>
              <br />
              <Text>{item.nombre}</Text>
              <CopyButton text={item.nombre} />
            </div>
          </Col>
          <Col span={12}>
            <div>
              <Text strong>Coordinador</Text>
              <br />
              <Text>{item.coordinador}</Text>
              <CopyButton text={item.coordinador} />
            </div>
          </Col>
        </Row>

        <Divider style={{ margin: '12px 0' }} />

        <div>
          <Text strong>Teléfono</Text>
          <br />
          <Text>{item.telefono}</Text>
          <CopyButton text={item.telefono} />
        </div>

        {item.celular && item.celular !== 'nan' && (
          <div>
            <Text strong>Celular</Text>
            <br />
            <Text>{item.celular}</Text>
            <CopyButton text={item.celular} />
          </div>
        )}

        <div>
          <Text strong>Correo</Text>
          <br />
          <Text>{item.correo}</Text>
          <CopyButton text={item.correo} />
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <div>
          <Text strong>Dirección</Text>
          <br />
          <Text>{item.direccionCdr}</Text>
          <CopyButton text={item.direccionCdr} />
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <div style={{ marginBottom: 8 }}>
          <Text strong>Horarios</Text>
        </div>

        <Row gutter={[8, 8]}>
          <Col span={12}>
            <div>
              <Text type="secondary" style={{ fontSize: '12px' }}>Ingresos L-V</Text>
              <br />
              <Tag color="blue">{item.horarioIngresosLV}</Tag>
            </div>
          </Col>
          <Col span={12}>
            <div>
              <Text type="secondary" style={{ fontSize: '12px' }}>Egresos L-V</Text>
              <br />
              <Tag color="green">{item.horarioEgresosLV}</Tag>
            </div>
          </Col>
        </Row>

        <div>
          <Text type="secondary" style={{ fontSize: '12px' }}>Sábado</Text>
          <br />
          <Tag color="orange">{item.horarioSabatinoIngresoEgreso}</Tag>
        </div>
      </Space>
    </Card>
  );
};